import { createSlice } from '@reduxjs/toolkit';
import { merge, reduce } from 'lodash';

import { ENTITY_TYPES } from 'src/constants';

const initialState = reduce(
  ENTITY_TYPES,
  (result) => {
    result = merge(
      {
        wallet: null,
        loading: false,
      },
    );
    return result;
  },
  {},
);

const slice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    createWalletStart(state, { payload }) { },
    createWalletSuccess(state, { payload }) { },
    createWalletFailure(state, { payload }) { },
    getWalletStart(state, { payload }) {
      state.loading = true;
    },
    getWalletSuccess(state, { payload }) {
      const { response } = payload;
      state.wallet = response;
      state.loading = false;
    },
    getWalletFailure(state, { payload }) { },
    editWalletStart(state, { payload }) {
      state.loading = true;
    },
    editWalletSuccess(state, { payload }) {
      const { response } = payload;
      state.loading = false;
      state.wallet = response;
    },
    editWalletFailure(state, { payload }) { },
  },
});

export const { actions } = slice;

export default slice.reducer;
